import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Featured from "./Featured";
import Item from "./Item";
import CallToAction from "./CallToAction";
import styles from "./styles.css";

const Submenu = React.forwardRef((props, ref) => {
  const {
    items,
    featured,
    call_to_action: callToAction,
    className,
    ...rest
  } = props;

  return (
    <div {...rest} className={cn(styles.submenu, className)} ref={ref}>
      {featured && <Featured {...featured} className={styles.featured} />}

      <div className={styles.list}>
        {items.map((item) => (
          <Item {...item} key={item.title} />
        ))}
      </div>

      {callToAction && <CallToAction {...callToAction} />}
    </div>
  );
});

Submenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  featured: PropTypes.shape({}),
  call_to_action: PropTypes.shape({}),
  className: PropTypes.string,
};

Submenu.defaultProps = {
  featured: null,
  call_to_action: null,
  className: "",
};

export default Submenu;
